import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import masterReducer from "./allReducers";

export default createStore(masterReducer, applyMiddleware(thunkMiddleware));
